import React from "react";
import { View, StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    maxWidth: 605,
    alignSelf: "center",
    width: "100%",
    marginHorizontal: "auto",
  },
});

const Container: React.FC = ({ children }) => {
  return <View style={styles.container}>{children}</View>;
};

export default Container;
